import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';
import Font from '../../styles/font';

export const StyledSiteNav = styled.div`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.colors.nav.isSiteNavDark
      ? theme.colors.nav.headerDark
      : theme.colors.nav.header};
  color: ${COLOR.white};
  height: 52px;
  margin: auto;

  display: flex;
  align-items: center;
`;

export const StyledSiteNavButton = styled.button.attrs(props =>
  (props as any).as ? {} : { type: 'button' }
)`
  min-width: 52px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  background-color: transparent;

  cursor: pointer;

  appearance: none;

  &:hover {
    &:last-child {
      background-color: ${THEME.shadow.light};
    }
    & svg,
    & svg * {
      fill: currentColor;
    }
  }
`;

export const StyledSignInButton = styled(StyledSiteNavButton).attrs(() => ({
  className: Font.f13_bold_tall_upper,
  children: 'SIGN IN',
  as: 'a'
}))`
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  white-space: nowrap;
  padding: 8px 16px;
  color: ${COLOR.white};

  ${MediaQuery.Tablet} {
    border-radius: 4px;
    margin-right: 20px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    align-self: center;
  }
`;

export const StyledRightNavContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: stretch;
  height: 100%;
`;
